import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "list-group-item list-group-item-action crm:flex! crm:justify-between! crm:items-center! crm:cursor-pointer!" }
const _hoisted_2 = { class: "text-black-50" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "text-black" }
const _hoisted_5 = { class: "text-black-50" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-primary" }

import {formatDateEnToIT} from '../filters/common.filters.js'
import {inject} from "vue";


export default {
  __name: 'BaseNotifica',
  props: {
  /**
   * Dati della notifica
   * @example {notifica_id: 1, timestamp: 'DATA', titolo: 'Informazioni richieste completate', descrizione: 'ha completato le informazioni richieste', identificativo_pratica: '123456', natura_atto: '23'}
   */
  notifica: {
    type: Object,
    default() {
      return {}
    }
  }
},
  emits: [
  /**
   * Emitta l'apertura di una singola notifica
   */
  'apriNotifica',
  /**
   * Espone un emit quando si setta la singola notifica come letta
   */
  'setNotificaLetta'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc Gestisce la visualizzazione di una singola notifica
 */

const props = __props

const emits = __emit;

/**
 * Emitta l'apertura di una notifica
 */
function apriNotifica() {
  emits('apriNotifica', props.notifica)
}

/**
 * @inject {$AxiosClient} recupera la libreria per le chiamate ajax
 */
const $AxiosClient = inject('$AxiosClient');

/**
 * Imposta la singola notifica come già letta
 * @return {Promise<void>}
 */
async function segnaComeLettaNotifica() {
  let setTutteNotificheLette = await $AxiosClient.post('Notifiche', 'setNotificaLetta', {
    pratica_id: props.notifica.pratica_id,
    notifica_id: props.notifica.notifica_id
  }, {messages: 'error'});

  if (setTutteNotificheLette.esito === 'ok') {
    emits('setNotificaLetta', props.notifica.notifica_id)
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "crm:flex crm:flex-col",
      onClick: _withModifiers(apriNotifica, ["prevent"])
    }, [
      _createElementVNode("small", _hoisted_2, [
        _createElementVNode("span", {
          innerHTML: _unref(formatDateEnToIT)(__props.notifica.timestamp)
        }, null, 8 /* PROPS */, _hoisted_3),
        _createTextVNode(" - " + _toDisplayString(__props.notifica.notifica_id), 1 /* TEXT */)
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.notifica.titolo), 1 /* TEXT */),
      _createElementVNode("small", _hoisted_5, [
        (__props.notifica.identificativo_pratica)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.notifica.identificativo_pratica), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (__props.notifica.natura_atto)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.notifica.natura_atto), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("small", _hoisted_8, _toDisplayString(__props.notifica.descrizione), 1 /* TEXT */)
    ]),
    _createElementVNode("div", {
      class: "crm:w-[18px] crm:h-[10px] crm:rounded-full crm:ml-2 crm:bg-secondary crm:cursor-pointer crm:hover:bg-primary",
      onClick: _withModifiers(segnaComeLettaNotifica, ["prevent"])
    })
  ]))
}
}

}